module.exports = __webpack_public_path__ + "static/the-hellfire-club-72b4929676f7fd899f13f79d0707915a.jpg";